<template>
  <!-- 人脸识别 -->
  <div class="test-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="year_num1" placeholder="请输入年份"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submit"
            >保存</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="refresh"
            >刷新</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">当前限制年份：{{ year_num }}</div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'

export default {
  data() {
    return {
      loading: false, //加载动画
      year_num1: '',//输入年份
      year_num: '',//限制年份
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取数据
    getData() {
      this.loading = true
      getApiData('face_year_set').then(res => {
        if (res) {
          this.year_num = res.year
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 保存
    submit() {
      if (!this.year_num1) {
        this.$message.warning("年份不能为空")
        return
      }
      let params = {
        year: this.year_num1
      }
      postApiData('face_year_set', params).then(res => {
        if (res.code) {
          this.$message.success(res.message)
          this.getData()//刷新
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
      })
    },
    // 刷新
    refresh() {
      this.$confirm('确定要刷新年份吗？', {
        type: 'warning'
      }).then(res => {
        postApiData('face_flush').then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.getData()//刷新
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
  }

}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>
